import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import { ChevronDown, ChevronRight } from 'apollo-react-icons';
import React, { memo } from 'react';

const useStyles = makeStyles({
  expandCell: {
    marginTop: 5,
    minWidth: 30,
  },
});

const ExpandCell = memo(({ row: { Id, HasChildren, handleToggleRow, expanded } }) => {
  const classes = useStyles();

  const onClickButton = () => {
    handleToggleRow(Id);
  };

  const isExpandable = !!HasChildren;

  return isExpandable ? (
    <div className={classes.expandCell}>
      <Tooltip title={expanded ? 'Collapse' : 'Expand'} disableFocusListener>
        <IconButton
          size="small"
          onClick={onClickButton}
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          {expanded ? <ChevronDown /> : <ChevronRight />}
        </IconButton>
      </Tooltip>
    </div>
  ) : (
    <div className={classes.expandCell}></div>
  );
});

export default ExpandCell;
